/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import { Tab, Tabs } from "react-bootstrap";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";

class LinkPartner extends React.Component {
  state = {
    showModal: false,
    authorized: false,
  };

  checkAuthorized = () => {
    fetch(`/apps/cloudfarm/is_croplet_authorized/${this.props.gid}/`).then((response) => {
      if (response.ok) {
        response.json().then((response) => {
          this.setAuthorized(response.authorized);
        });
      } else {
        this.setAuthorized(false);
      }
    });
  };

  setAuthorized(authorized) {
    this.setState({
      authorized: authorized,
    });
    if (this.props.setAuthorized) {
      this.props.setAuthorized(authorized);
    }
  }

  deleteTokens = () => {
    if (cropr.confirm(gettext("Do you want to retract the authorization?"))) {
      fetch(`/apps/cloudfarm/retract_croplet_authorization/${this.props.gid}/`, {
        method: "POST",
        credentials: "same-origin",
        headers: { "X-CSRFToken": cropr.getCookie("csrftoken") },
      }).then((response) => {
        if (response.ok) {
          cropr.notify("success", gettext("Authorization has been retracted."));
          this.setAuthorized(false);
        } else {
          cropr.notify("danger", gettext("Failure"));
        }
      });
    }
  };

  toggle(show) {
    this.setState({ showModal: show });
    if (show) {
      this.checkAuthorized();
    }
  }

  render() {
    return (
      <>
        <a href="#" className="dropdown-item" onClick={() => this.toggle(true)}>
          {interpolate(gettext("Link with %s"), [this.props.name])}
        </a>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              {this.props.name}
              <img
                className="float-right"
                src={this.props.logo_url}
                alt="AVR"
                style={{ height: `${this.props.logo_height}px` }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey="account">
              <Tab eventKey="account" title={gettext("Authorization")}>
                <h5 className="mt-2">
                  {interpolate(
                    this.state.authorized
                      ? gettext("%s has been authorized.")
                      : gettext("%s is not authorized."),
                    [this.props.name]
                  )}
                </h5>
                <div className="mt-2">{this.props.description}</div>
                {this.state.authorized ? (
                  <div className="my-2">
                    <a href="#" onClick={this.deleteTokens} className="btn btn-warning mr-1">
                      {gettext("Retract authorization")}
                    </a>
                  </div>
                ) : null}
              </Tab>
              {this.props.children}
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkPartner;
